import { colors } from "../../style";
import { Icon } from "./Icon";
import { ui } from "./styles";

const chipSizes = {
  md: { padding: "3px 9px", fontSize: "12px" },
  sm: { padding: "1px 8px", fontSize: "11px" },
};

// Pill tinted from one colour (direction, capture, sentiment)
// as="button" for a clickable chip
export function Chip({
  color,
  icon,
  size = "md",
  as: As = "span",
  children,
  style,
  ...props
}) {
  return (
    <As
      type={As === "button" ? "button" : undefined}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        ...chipSizes[size],
        borderRadius: "999px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        color,
        background: `${color}29`,
        ...(As === "button" && {
          border: "1px solid transparent",
          fontFamily: "inherit",
          cursor: "pointer",
        }),
        ...style,
      }}
      {...props}
    >
      {icon && <Icon name={icon} size={12} />}
      {children}
    </As>
  );
}

export function StatusDot({ color, title, pulse, size = 8, style }) {
  return (
    <span
      title={title}
      className={pulse ? "sk-pulse" : undefined}
      style={{
        display: "inline-block",
        flex: "none",
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        ...style,
      }}
    />
  );
}

export function Kbd({ children }) {
  return <kbd style={ui.kbd}>{children}</kbd>;
}

// Initials of `name` in a circle
export function Avatar({ name, size = 30, color = colors.violet }) {
  const initials = name
    ?.split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return (
    <span
      aria-hidden="true"
      style={{
        flex: "none",
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        color: colors.pageBackground,
        fontSize: Math.round(size * 0.4),
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {initials}
    </span>
  );
}

export function Spinner({ size = 16, color = colors.teal, label = "Loading" }) {
  return (
    <span
      className="sk-spinner"
      aria-label={label}
      style={{
        display: "inline-block",
        flex: "none",
        width: size,
        height: size,
        borderRadius: "50%",
        border: `2px solid ${color}40`,
        borderTopColor: color,
      }}
    />
  );
}
